import { createAction } from 'typesafe-actions';
import { IDisease } from '../../../types/model/masterData/disease';

export default class DiseaseActions {
    public static setLoading = createAction('MASTER_DATA_DISEASE_SET_LOADING', resolve => (loading : boolean) => resolve(loading));
    public static setList = createAction('MASTER_DATA_DISEASE_SET', resolve => (blocks : Array<IDisease>) => resolve(blocks));
}